import React from 'react';
import Section from '../layout/Section';

const ArchitectureSection: React.FC = () => {
  return (
    <Section
      kicker="Architecture"
      title="Policy-driven, not magic-driven."
      body="One configuration file describes your LUKS targets, ZFS datasets, USB expectations, timeouts and fallbacks. The engine is wiring; the policy is yours."
    >
      <div className="lc-grid lc-grid--2">
        <article className="lc-card">
          <h3 className="lc-card-title">ZFS provider</h3>
          <p className="lc-card-body">
            The ZFS provider orchestrates unlock attempts against the host&apos;s native{' '}
            <code>zfs</code>/<code>zpool</code> binaries. Exit codes and output are mapped into
            stable, testable behaviour — no ad-hoc parsing, no guessing games.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">LUKS provider</h3>
          <p className="lc-card-body">
            The <code>lockchain-luks</code> crate targets <code>cryptsetup</code>, reads{' '}
            <code>crypttab</code> entries, and hooks into the initrd so LUKS volumes open through
            the same policy engine as ZFS. Currently scaffolded; active development next.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">USB key workflow</h3>
          <p className="lc-card-body">
            A dedicated USB stick carries key material for both LUKS and ZFS targets. Policy
            describes labels, UUIDs, key paths, checksums and mount timeouts — the vault only opens
            when the right device is present and healthy.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Fallback &amp; observability</h3>
          <p className="lc-card-body">
            Fallback behaviour — passphrase prompts via <code>systemd-ask-password</code>, retry
            budgets, backoff and jitter — is explicit configuration. Structured error codes make
            LockChain pluggable into logging and alerting pipelines.
          </p>
        </article>
      </div>
    </Section>
  );
};

export default ArchitectureSection;
